import { removeClassificationLink } from './getRemoveClassificationLink.locstring.json';
import loc from 'owa-localize';
import {
    InfoBarCustomAction,
    InfoBarHostViewState,
} from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import clearClassification from 'owa-mail-protection/lib/utils/classification/clearClassification';
import ClassificationViewState from 'owa-mail-protection-types/lib/schema/classification/ClassificationViewState';

export default function getRemoveClassificationLink(
    viewState: ClassificationViewState,
    infoBarViewState: InfoBarHostViewState
): InfoBarCustomAction {
    return {
        text: loc(removeClassificationLink),
        action: () => {
            clearClassification(viewState, infoBarViewState);
        },
    };
}
